import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=45a9b496&"
import script from "./CalendarView.vue?vue&type=script&lang=js&"
export * from "./CalendarView.vue?vue&type=script&lang=js&"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=45a9b496&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports